module.exports = __webpack_public_path__ + "static/media/email-icon.f7e1dde0.svg";